import useReactHookForm from "hooks/useReactHookForm";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import {
  subjectInitialValues,
  subjectValidationSchema,
  subjectPropertiesUpdate,
} from "./helper";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useLazyQuery } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";
import { getQueryParam, isEmpty } from "utils/helpers";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { GET_SUBJECT_LIST } from "utils/graphql/services/global-content-hierarchy/queries";
import { Typography, Box } from "@mui/material";

export const SubjectUpdate = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    subjectInitialValues,
    subjectValidationSchema,
    ""
  );
  const [getSubjectList, { loading, error, data }] = useLazyQuery(
    GET_SUBJECT_LIST,
    {
      client: entitesClient,
    }
  );

  const location = useLocation();
  const id = getQueryParam("id", location);
  const status = getQueryParam("status", location);

  useEffect(() => {
    if (!isEmpty(data?.getSubjects?.records)) {
      const subject = data?.getSubjects?.records?.[0];
      if (!isEmpty(subject)) {
        setValue("global_name", subject?.global_name);
        setValue("status", subject?.status);
        setValue("gcf_public_subject_id", subject?.gcf_public_subject_id);
        setValue("subject_code", subject?.subject_code);
        setValue("image_url", subject?.image_url);
        setValue("tags", subject?.tags);
        setValue("synonyms", subject?.synonyms);
        setValue("sbd_subject_id", subject?.sbd_subject_id);
        setValue("assets", subject?.assets);
        setValue("gcf_public_subject_name", subject?.gcf_public_subject_name);
        setValue(
          "npractice_public_subject_id",
          subject?.npractice_public_subject_id
        );
        setValue(
          "npractice_public_subject_name",
          subject?.npractice_public_subject_name
        );
        setValue(
          "npractice_practice_subject_id",
          subject?.npractice_practice_subject_id
        );
        setValue(
          "npractice_practice_subject_name",
          subject?.npractice_practice_subject_name
        );
        setValue("nexam_public_subject_id", subject?.nexam_public_subject_id);
        setValue(
          "nexam_public_subject_name",
          subject?.nexam_public_subject_name
        );
      }
    }
  }, [data]);

  useEffect(() => {
    getSubjectList({
      variables: {
        filter: {
          id: +id,
          status,
        },
      },
    });
  }, []);

  if (loading) {
    return <p>loading......</p>;
  }

  return (
    <div>
      <TypographyHeading>Subject</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={subjectPropertiesUpdate}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        </Grid>

        <Box sx={{ p: 2 }}>
          <Typography variant="h6">Assets</Typography>
          <Typography
            component="pre"
            sx={{
              bgcolor: "grey.100",
              p: 2,
              borderRadius: 1,
              overflow: "auto",
            }}
          >
            {JSON.stringify(watch()?.assets||{}, null, 2)}
          </Typography>
        </Box>
        <Box sx={{ p: 2 }}>
          <Typography variant="h6">Tags</Typography>
          <Typography
            component="pre"
            sx={{
              bgcolor: "grey.100",
              p: 2,
              borderRadius: 1,
              overflow: "auto",
            }}
          >
            {JSON.stringify(watch()?.tags||{}, null, 2)}
          </Typography>
        </Box>
      </Paper>
    </div>
  );
};
